function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from "react";
import isNotEmpty from "../../../../../utils/isNotEmpty";
import BadgeAtm from "../../../../atoms/BadgeAtm";
import TextAtm from "../../../../atoms/TextAtm";
import FlexContainerOrg from "../../../../organisms/FlexContainerOrg";
import PushOrg from "../../../../organisms/PushOrg";
import { pricesTypographies } from "../../priceMol.config";
import { PriceVariantType } from "../../priceMol.types";
import { PriceContainer, Pointer } from "./MainPriceElement.styled";
var MainPriceElement = function MainPriceElement(_ref) {
  var _mainPrice$dataTest, _mainPrice$dataTest2;
  var mainPrice = _ref.mainPrice,
    badgeText = _ref.badgeText,
    hasPromo = _ref.hasPromo,
    variant = _ref.variant,
    hasCrossedPriceSafeSpace = _ref.hasCrossedPriceSafeSpace;
  var typographies = pricesTypographies[variant.type];
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    pointerPosition = _useState2[0],
    setPointerPosition = _useState2[1];
  var priceContainerRef = useRef(null);
  var badgeRef = useRef(null);
  var observerRef = useRef(null);
  var pointerOffset = 16;
  useEffect(function () {
    var calculatePointerPosition = function calculatePointerPosition() {
      var container = priceContainerRef.current;
      var badge = badgeRef.current;
      if (container && badge) {
        var newPosition = container.offsetWidth / 2 - pointerOffset;
        if (container.offsetWidth > badge.offsetWidth && variant.align !== "center") {
          newPosition = badge.offsetWidth / 2 - pointerOffset;
        }
        setPointerPosition(newPosition);
      }
    };
    observerRef.current = new ResizeObserver(function () {
      calculatePointerPosition();
    });
    if (priceContainerRef.current) {
      observerRef.current.observe(priceContainerRef.current);
    }
    return function () {
      var _observerRef$current;
      (_observerRef$current = observerRef.current) === null || _observerRef$current === void 0 || _observerRef$current.disconnect();
    };
  }, [variant.align, variant.type]);
  var crossedPriceElement = isNotEmpty(mainPrice.crossedPrice) ? /*#__PURE__*/React.createElement(TextAtm, _extends({
    hasLineThrough: true
  }, typographies.crossedPrice), mainPrice.crossedPrice) : null;
  var currentPriceElement = /*#__PURE__*/React.createElement(TextAtm, _extends({
    color: hasPromo ? "primary" : undefined,
    "data-test-id": (_mainPrice$dataTest = mainPrice.dataTest) === null || _mainPrice$dataTest === void 0 ? void 0 : _mainPrice$dataTest.currentPriceDataTestId
  }, typographies.currentPrice), mainPrice.currentPrice);
  var periodText = /*#__PURE__*/React.createElement(TextAtm, _extends({
    "data-test-id": (_mainPrice$dataTest2 = mainPrice.dataTest) === null || _mainPrice$dataTest2 === void 0 ? void 0 : _mainPrice$dataTest2.periodTextDataTestId
  }, typographies.periodText), mainPrice.periodText);
  var badgeElement = badgeText ? /*#__PURE__*/React.createElement("div", {
    ref: badgeRef
  }, /*#__PURE__*/React.createElement(BadgeAtm, null, /*#__PURE__*/React.createElement(TextAtm, typographies.badgeText, badgeText))) : null;
  var pointerElement = badgeText ? /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: variant.type !== PriceVariantType.LARGE ? 1 : 0
  }, /*#__PURE__*/React.createElement(Pointer, {
    $position: pointerPosition,
    $variant: variant
  })) : undefined;
  if (variant.type === PriceVariantType.SMALL) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PriceContainer, {
      ref: priceContainerRef,
      $variant: variant.type
    }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
      alignItems: "baseline",
      wrap: "wrap",
      justifyContent: "flex-end"
    }, crossedPriceElement ? /*#__PURE__*/React.createElement(PushOrg, {
      rightSpace: 1
    }, crossedPriceElement) : null, /*#__PURE__*/React.createElement(PushOrg, {
      rightSpace: 0.5
    }, currentPriceElement), periodText), pointerElement), badgeElement);
  }
  if (variant.type === PriceVariantType.MEDIUM) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PriceContainer, {
      ref: priceContainerRef,
      $variant: variant.type
    }, crossedPriceElement ? /*#__PURE__*/React.createElement(PushOrg, {
      rightSpace: 0.5
    }, crossedPriceElement) : null, /*#__PURE__*/React.createElement(FlexContainerOrg, {
      alignItems: "baseline",
      wrap: "wrap"
    }, /*#__PURE__*/React.createElement(PushOrg, {
      rightSpace: 0.5
    }, currentPriceElement), periodText), pointerElement), badgeElement);
  }
  if (variant.type === PriceVariantType.LARGE) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PriceContainer, {
      ref: priceContainerRef,
      $variant: variant.type,
      $hasCrossedPriceSafeSpace: hasCrossedPriceSafeSpace
    }, crossedPriceElement, currentPriceElement, periodText, pointerElement), isNotEmpty(badgeElement) ? /*#__PURE__*/React.createElement(PushOrg, {
      topSpace: 0.5
    }, badgeElement) : null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default MainPriceElement;